const CLOSE_MEMBER_PHOTO = 'CLOSE_MEMBER_PHOTO';

const MEMBER_PHOTO_LOAD_REQUEST = 'MEMBER_PHOTO_LOAD_REQUEST';
const MEMBER_PHOTO_LOAD_SUCCESS = 'MEMBER_PHOTO_LOAD_SUCCESS';
const MEMBER_PHOTO_LOAD_ERROR = 'MEMBER_PHOTO_LOAD_ERROR';

const MEMBER_PHOTO_LIKE_REQUEST = 'MEMBER_PHOTO_LIKE_REQUEST';
const MEMBER_PHOTO_LIKE_SUCCESS = 'MEMBER_PHOTO_LIKE_SUCCESS';
const MEMBER_PHOTO_LIKE_ERROR = 'MEMBER_PHOTO_LIKE_ERROR';

const MEMBER_PHOTO_COMMENT_REQUEST = 'MEMBER_PHOTO_COMMENT_REQUEST';
const MEMBER_PHOTO_COMMENT_SUCCESS = 'MEMBER_PHOTO_COMMENT_SUCCESS';
const MEMBER_PHOTO_COMMENT_ERROR = 'MEMBER_PHOTO_COMMENT_ERROR';

import * as backend from 'backend-helpers/memberPhoto';

const initState = {
    memberPhoto: null,
    list: [],
    _isFetching: false
};

export default function memberPhoto(state = initState, action) {
    if (action.type === MEMBER_PHOTO_LOAD_REQUEST) {
        return {
            ...state,
            _isFetching: true
        }
    }

    if (action.type === MEMBER_PHOTO_LOAD_SUCCESS) {
        let {memberPhoto} = action.result.data;
        let {list} = action;

        return {
            memberPhoto,
            list: list || state.list,
            _isFetching: false
        }
    }

    if (action.type === MEMBER_PHOTO_LOAD_ERROR) {
        return initState;
    }

    if (action.type === CLOSE_MEMBER_PHOTO) {
        return initState
    }

    return state;
}

export function openMemberPhoto(memberPhoto, list = null) {
    return {
        types: [MEMBER_PHOTO_LOAD_REQUEST, MEMBER_PHOTO_LOAD_SUCCESS, MEMBER_PHOTO_LOAD_ERROR],
        promise: backend.getMemberPhoto(memberPhoto.id),
        list
    }

}

export function closeMemberPhoto() {
    return {
        type: CLOSE_MEMBER_PHOTO
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberPhoto.js